"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateRevertCharPos = void 0;
/**
 * This migration got introduced because we were using an internal type in the game for character position
 * which is different from schema. They have now been sycned up
 */
const migrateRevertCharPos = async (story) => {
    story.steps = story.steps.map((step) => {
        step.gestures = step.gestures.map((gesture) => ({
            ...gesture,
            charPos: {
                x: gesture.charPos.from.x,
                y: gesture.charPos.from.y,
            }
        }));
        return step;
    });
    return story;
};
exports.migrateRevertCharPos = migrateRevertCharPos;
//# sourceMappingURL=migrateRevertCharPos.js.map